import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import AgentsTable from "../../components/agents/AgentsTable";

const Agents = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <AgentsTable />
        </WrapperSection>
    );
};

export default Agents;
